import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import DarkTourismExplained from "./pages/DarkTourismExplained";
import Explore from "./pages/Explore";
import WallOfStories from "./pages/WallOfStories";
import Guidelines from "./pages/Guidelines";
import Itineraries from "./pages/Itineraries";
import NewsMedia from "./pages/NewsMedia";
import ShareStory from "./pages/ShareStory";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/dark-tourism-explained" element={<DarkTourismExplained />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/wall-of-stories" element={<WallOfStories />} />
          <Route path="/guidelines" element={<Guidelines />} />
          <Route path="/itineraries" element={<Itineraries />} />
          <Route path="/news-media" element={<NewsMedia />} />
          <Route path="/share-story" element={<ShareStory />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
